import { tabletMax } from '@propertypal/shared/src/constants/mediaQueries';
import soldPriceBg from '@propertypal/shared/src/resources/bg/sold-data-bg.jpg';
import styled from 'styled-components';
import { Container as TextInput } from '../inputs/TextInput.style';

export const Header = styled.div`
  background-image: url(${soldPriceBg.src});
  background-position: center;
  background-size: cover;
  width: 100%;
  height: 345px;
  display: flex;
  align-items: center;
  justify-content: center;

  h1 {
    color: ${(props) => props.theme.white};
    font-weight: 300;
    font-size: 48px;
    text-align: center;
    text-shadow:
      0 0 0 rgba(0, 0, 0, 0.3),
      0 0 1px rgba(0, 0, 0, 0.5),
      0 0 12px rgba(0, 0, 0, 0.7);
  }
`;

export const InputBox = styled.div`
  padding: 30px 0;
  background: ${(props) => props.theme.backgroundLight};
`;

export const InputRow = styled.div`
  display: flex;
  flex-direction: row;

  ${TextInput} {
    flex: 1;
    margin-right: 30px;
  }

  @media (${tabletMax}) {
    flex-direction: column;

    ${TextInput} {
      margin-right: 0;
      margin-bottom: 30px;
    }
  }
`;
